import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { isFeatureEnabled } from './features';

export const featureGuard = (flag: string, requiredPermission?: string): CanActivateFn => () => {
  const router = inject(Router);
  if (!isFeatureEnabled(flag)) return router.createUrlTree(['/']);
  if (requiredPermission && !inject(AuthService).can(requiredPermission)) {
    return router.createUrlTree(['/']);
  }
  return true;
};
